import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { SnackbarProvider } from './view/components/SnackbarService';
import AppRouter from './routing/AppRouter';
import './App.scss';
import { AuthProvider } from './auth/AuthContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#45987A', // Using the $primary color from your SCSS variables
    },
    secondary: {
      main: '#1a1a1a', // Using the $golden color from your SCSS variables
    },
    error: {
      main: '#FF0000', // Using the $red color from your SCSS variables
    },
    success: {
      main: '#00FF00', // Using the $green color from your SCSS variables
    },
    background: {
      default: '#ffffff',
    },
    warning: {
      main: '#ffb400', // Using the $orange color from your SCSS variables
    },
    text: {
      primary: '#151E15',
      secondary: '#ffb400',
      disabled: '#888888',
    },
  },
  typography: {
    fontFamily: 'Century Gothic, Poppins, Arial, sans-serif', // Combining your custom fonts
    fontSize: 14,
    button: {
      textTransform: 'none',
    },
    h1: {
      fontSize: '2.375rem', // Matches $h1-font-size
    },
    h2: {
      fontSize: '2rem', // Matches $h2-font-size
    },
    h3: {
      fontSize: '1.75rem', // Matches $h3-font-size
    },
    h4: {
      fontSize: '1.5rem', // Matches $h4-font-size
    },
    h5: {
      fontSize: '1.25rem', // Matches $h5-font-size
    },
    h6: {
      fontSize: '1rem', // Matches $h6-font-size
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SnackbarProvider>
          <CssBaseline />
          <AppRouter />
        </SnackbarProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
